import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { t } from '../i18n'
import { useUi } from '../State/Ui'
import { track } from '../Utils/analytics'
import { ArticleLink, CardMeta } from './StoryCard'
import { BestComment, CommentButton } from './Comments'
import { ChevronRight } from './Icons'
import ShareButton from './ShareButton'
import { SourceAvatar } from './SourceAvatar'
import TopicTag from './TopicTag'

/* Big card (spec 5.3): bigger title and the "Drugi pišu" box, no picture.
   variant:
   - "main": Glavna vijest on Početna (with the label)
   - "shared": a shared link's story (same card, no label, spec 5.5)
   - "story": top of the story page (no label, no box: the list follows) */
export default function MainStoryCard({ story, variant = 'main', isNew = false, from = 'main' }) {
  const { isMobile } = useUi()
  const navigate = useNavigate()
  const others = (story.othersPreview || []).slice(0, isMobile ? 2 : 3)
  const withBox = variant !== 'story' && others.length > 0
  const openStory = () => {
    track('story_open', { source: 'drugi_pisu', from })
    navigate(`/prica/${story.id}`)
  }

  return (
    <article className={`story-card main-card main-card-${variant}`}>
      {variant === 'main' && (
        <div className="main-label">
          <span className="topic-dot" aria-hidden="true" />
          {t('card.mainLabel')}
        </div>
      )}
      <TopicTag topic={story.topic} />
      <CardMeta story={story} isNew={isNew} from={from} />
      <h2 className="main-title">
        <ArticleLink story={story} from={from}>
          {story.title}
        </ArticleLink>
      </h2>

      {withBox ? (
        // The whole box opens the story; its link is the keyboard way in.
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        <div className="others-box" onClick={openStory}>
          <div className="others-title">{t('card.othersWrite')}</div>
          <ul className="others-list">
            {others.map((a) => (
              <li key={a.id} className="others-row">
                <SourceAvatar source={a.source} size={20} />
                <span className="others-source">{a.source.name}</span>
                {a.isFollowed && <span className="tag-following">{t('card.following')}</span>}
                <span className="others-headline">{a.title}</span>
              </li>
            ))}
          </ul>
          <div className="others-footer">
            <Link
              to={`/prica/${story.id}`}
              // On a shared link this is the same URL: a Link would replace
              // the entry and Back would leave the site.
              replace={false}
              className="link-orange"
              onClick={(e) => {
                e.stopPropagation()
                track('story_open', { source: 'drugi_pisu', from })
              }}
            >
              {t('card.allSources', { count: story.sourceCount })}
              <ChevronRight size={16} strokeWidth={2.5} />
            </Link>
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
            <div className="card-actions" onClick={(e) => e.stopPropagation()}>
              <CommentButton story={story} from={from} />
              <ShareButton story={story} from={from} />
            </div>
          </div>
        </div>
      ) : (
        <div className="card-footer">
          <span />
          <div className="card-actions">
            <CommentButton story={story} from={from} />
            <ShareButton story={story} from={from} />
          </div>
        </div>
      )}
      {/* The story's best comment, on the Glavna vijest only. */}
      {variant === 'main' && <BestComment story={story} from={from} />}
    </article>
  )
}
